module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/image-bank/image-bank.component.css
// module id = ./src/app/image-bank/image-bank.component.css
// module chunks = main